import React from 'react'
import { Box } from 'front-end/src/components'
import IconClockWait from '../../../../public/assets/img/icon-clock-wait.svg'
import { t, Trans } from '@lingui/macro'
import { ICampaignActionScheduleState } from './campaign-action-schedule-step-component/CampaignActionScheduleStepComponent'
import { Link } from 'react-router-dom'
import { staticLinks } from 'shared/linkBuilder'
import Message, {
  MessageTypes
} from 'front-end/src/components/common/message/Message'
import { CampaignActionToggleRow } from './CampaignActionToggleRow'

type RespectBusinessHoursSwitchPanelProps = {
  respectBusinessHours?: boolean
  onStateUpdate: (updatedState: Partial<ICampaignActionScheduleState>) => void
  businessHoursEnabledInOrg: boolean
  disabled: boolean
}

export const RespectBusinessHoursSwitchPanel: React.FC<RespectBusinessHoursSwitchPanelProps> =
  ({
    respectBusinessHours,
    onStateUpdate,
    businessHoursEnabledInOrg,
    disabled
  }) => {
    return (
      <>
        <CampaignActionToggleRow
          disabled={disabled}
          tooltip={
            disabled
              ? t`This can not be changed once the action is already saved.`
              : ''
          }
          checked={!!respectBusinessHours}
          onChange={async () => {
            onStateUpdate({
              respect_business_hours: !respectBusinessHours
            })
          }}
          description={
            <Trans>
              The time restriction which will follow{' '}
              <Link to={staticLinks.accountCampaigns}>business hours</Link> set
              in the Account settings.
            </Trans>
          }
          icon={IconClockWait}
          title={t`Respect business hours`}
        />

        {!businessHoursEnabledInOrg && respectBusinessHours && (
          <Message type={MessageTypes.WARNING} mt="0.5rem" mb={'32px'}>
            <Box>
              <Trans>
                Looks like your organisation doesn't have{' '}
                <Link to={staticLinks.accountCampaigns}>business hours</Link>{' '}
                enabled. Therefore, this option will be suspended until this
                changes.
              </Trans>
            </Box>
          </Message>
        )}
      </>
    )
  }
